import {
	API_GET_ALL_BOX_LIVE,
	API_PUT_BOX_AVAILABLE,
	API_PUT_BOX_BUSY,
	API_GET_MY_BOX_STATUS
} from 'actions/live';


export function getAllLiveBoxes() {
	return {
		type: API_GET_ALL_BOX_LIVE,
		payload: {
			request: {
				url: `/live`,
			},
		},
	};
}



export function setAvailableBox(box) {
	return {
		type: API_PUT_BOX_AVAILABLE,
		payload: {
			request: {
				url: `/live`,
				method: 'PUT',
				data: box
			},
		},
	};
}

export function setBusyBox(box) {
	return {
		type: API_PUT_BOX_BUSY,
		payload: {
			request: {
				url: `/live/busy`,
				method: 'PUT',
				data: box
			},
		},
	};
}

export function getBoxStatus(box) {
	return {
		type: API_GET_MY_BOX_STATUS,
		payload: {
			request: {
				url: `/live/box`,
				method: 'GET',
				params: box
			},
		},
	};
}